import api from "../services/api";

export const FETCH_REFERRALS = "FETCH_REFERRALS";
export const FETCH_INDUSTRIES = "FETCH_INDUSTRIES";
export const FETCH_COMPANY_SIZES = "FETCH_COMPANY_SIZES";

export const FETCH_SCHOOLS = "FETCH_SCHOOLS";
export const SEARCH_SCHOOLS_START = "SEARCH_SCHOOLS_START";
export const FETCH_WORK_RELATIONSHIP = "FETCH_WORK_RELATIONSHIP";
export const GET_PROJECT_DURATIONS_SUCCESS = "GET_PROJECT_DURATIONS_SUCCESS";
export const GET_JOB_TYPES_SUCCESS = "GET_JOB_TYPES_SUCCESS";
export const GET_WORK_TYPES_SUCCESS = "GET_WORK_TYPES_SUCCESS";
export const GET_TAX_STATUS_SUCCESS = "GET_TAX_STATUS_SUCCESS";
export const GET_PROJECT_BUDGET_RATE_TYPES = "GET_PROJECT_BUDGET_RATE_TYPES";
export const CREATE_SCHOOL_SUCESS = "CREATE_SCHOOL_SUCESS";
export const GET_COMMUTE_CITIES_SUCCESS = "GET_COMMUTE_CITIES_SUCCESS";
export const GET_LEVELS_SUCCESS = "GET_LEVELS_SUCCESS";
export const CREATE_SCHOOLS = "FETCH_SCHOOLS";
export const GET_REFERENCE_RELATIONSHIPS_SUCCESS =
  "GET_REFERENCE_RELATIONSHIPS_SUCCESS";
export const GET_COMPANY_BUDGETS_SUCCESS = "GET_COMPANY_BUDGETS_SUCCESS";
export const GET_COMPANY_PAYMENT_METHODS_SUCCESS =
  "GET_COMPANY_PAYMENT_METHODS_SUCCESS";
export const GET_COMPANY_PAYMENT_TERMS_SUCCESS =
  "GET_COMPANY_PAYMENT_TERMS_SUCCESS";

export function onCreateSchoolsSuccess(data) {
  return {
    type: CREATE_SCHOOL_SUCESS,
    data
  };
}

export function onFetchReferralsSuccess(data) {
  return {
    type: FETCH_REFERRALS,
    data
  };
}

export function onFetchIndustriesSuccess(data) {
  return {
    type: FETCH_INDUSTRIES,
    data
  };
}

export function onFetchCompanySizesSuccess(data) {
  return {
    type: FETCH_COMPANY_SIZES,
    data
  };
}

export function onFetchSchoolsSuccess(data) {
  return {
    type: FETCH_SCHOOLS,
    data
  };
}

export function onSearchSchoolsStart() {
  return {
    type: SEARCH_SCHOOLS_START
  };
}

export function onFetchWorkRelationshipsSuccess(data) {
  return {
    type: FETCH_WORK_RELATIONSHIP,
    data
  };
}

export function onGetProjectDurationsSuccess(data) {
  return {
    type: GET_PROJECT_DURATIONS_SUCCESS,
    data
  };
}

export function onGetJobTypesSuccess(data) {
  return {
    type: GET_JOB_TYPES_SUCCESS,
    data
  };
}

export function onGetWorkTypesSuccess(data) {
  return {
    type: GET_WORK_TYPES_SUCCESS,
    data
  };
}

export function onGetTaxStatusSuccess(data) {
  return {
    type: GET_TAX_STATUS_SUCCESS,
    data
  };
}

export function onProjectBudgetRateTypesSuccess(data) {
  return {
    type: GET_PROJECT_BUDGET_RATE_TYPES,
    data
  };
}

export function onGetCommuteCitiesSuccess(data) {
  return {
    type: GET_COMMUTE_CITIES_SUCCESS,
    data
  };
}

export function onGetLevelsSuccess(data) {
  return {
    type: GET_LEVELS_SUCCESS,
    data
  };
}

export function onGetReferenceRelationships(data) {
  return {
    type: GET_REFERENCE_RELATIONSHIPS_SUCCESS,
    data
  };
}

export function onGetCompanyBudgets(data) {
  return {
    type: GET_COMPANY_BUDGETS_SUCCESS,
    data
  };
}

export function onGetCompanyPaymentMethodsSuccess(data) {
  return {
    type: GET_COMPANY_PAYMENT_METHODS_SUCCESS,
    data
  };
}

export function onGetCompanyPaymentTermsSuccess(data) {
  return {
    type: GET_COMPANY_PAYMENT_TERMS_SUCCESS,
    data
  };
}

/* */

export function fetchReferrals() {
  return dispatch => {
    api
      .getReferrals()
      .then(res => {
        dispatch(onFetchReferralsSuccess(res.data));
      })
      .catch(() => {});
  };
}

export function fetchIndustries() {
  return dispatch => {
    api
      .getIndustries()
      .then(res => {
        dispatch(onFetchIndustriesSuccess(res.data));
      })
      .catch(() => {});
  };
}

export function fetchCompanySizes() {
  return dispatch => {
    api
      .getCompanySizes()
      .then(res => {
        dispatch(onFetchCompanySizesSuccess(res.data));
      })
      .catch(() => {});
  };
}

export function fetchSchools() {
  return dispatch => {
    api
      .getSchools()
      .then(res => {
        let schools = res.data.data;
        for (let i = 0; i < schools.length; i++) {
          schools[i].school_id = schools[i]["id"];
          delete schools[i].id;
        }
        dispatch(onFetchSchoolsSuccess(schools));
      })
      .catch(() => {});
  };
}

export function updateSchools() {
  return dispatch => {
    api
      .getSchools()
      .then(res => {
        let schools = res.data.data;
        for (let i = 0; i < schools.length; i++) {
          schools[i].school_id = schools[i]["id"];
          delete schools[i].id;
        }
        dispatch(onFetchSchoolsSuccess(schools));
      })
      .catch(() => {});
  };
}

export function createSchools(query) {
  return dispatch => {
    return api
      .createSchools(query)
      .then(res => {
        dispatch(onCreateSchoolsSuccess(res.data.data));
        return res.data.data;
      })
      .catch(() => {});
  };
}

export function searchSchools(query) {
  return dispatch => {
    dispatch(onSearchSchoolsStart());
    api
      .searchSchools(query)
      .then(res => {
        let schools = res.data.data;
        for (let i = 0; i < schools.length; i++) {
          schools[i].school_id = schools[i]["id"];
          delete schools[i].id;
        }
        dispatch(onFetchSchoolsSuccess(schools));
      })
      .catch(() => {});
  };
}

export function fetchWorkRelationships() {
  return dispatch => {
    api
      .getWorkRelationships()
      .then(res => {
        dispatch(onFetchWorkRelationshipsSuccess(res.data));
      })
      .catch(() => {});
  };
}

export function getProjectDurations() {
  return dispatch => {
    api
      .getProjectDurations()
      .then(res => {
        dispatch(onGetProjectDurationsSuccess(res.data));
      })
      .catch(() => {});
  };
}

export function getJobTypes() {
  return dispatch => {
    api
      .getJobTypes()
      .then(res => {
        dispatch(onGetJobTypesSuccess(res.data));
      })
      .catch(() => {});
  };
}

export function getWorkTypes() {
  return dispatch => {
    api
      .getWorkTypes()
      .then(res => {
        dispatch(onGetWorkTypesSuccess(res.data));
      })
      .catch(() => {});
  };
}

export function getTaxStatus() {
  return dispatch => {
    api
      .getTaxStatus()
      .then(res => {
        dispatch(onGetTaxStatusSuccess(res.data));
      })
      .catch(() => {});
  };
}

export function getProjectBudgetRateTypes() {
  return dispatch => {
    api
      .getProjectBudgetRateTypes()
      .then(res => {
        dispatch(onProjectBudgetRateTypesSuccess(res.data));
      })
      .catch(() => {});
  };
}

export function getCommuteCities() {
  return dispatch => {
    api
      .getCommuteCities()
      .then(res => {
        dispatch(onGetCommuteCitiesSuccess(res.data));
      })
      .catch(() => {});
  };
}

export function getLevels() {
  return dispatch => {
    api
      .getLevels()
      .then(res => {
        dispatch(onGetLevelsSuccess(res.data));
      })
      .catch(() => {});
  };
}

export function getReferenceRelationships() {
  return dispatch => {
    api
      .getReferenceRelationships()
      .then(res => {
        dispatch(onGetReferenceRelationships(res.data));
      })
      .catch(() => {});
  };
}

export function getCompanyBudgets() {
  return dispatch => {
    api
      .getCompanyBudgets()
      .then(res => {
        dispatch(onGetCompanyBudgets(res.data));
      })
      .catch(() => {});
  };
}

export function getCompanyPaymentMethods() {
  return dispatch => {
    api
      .getCompanyPaymentMethods()
      .then(res => {
        dispatch(onGetCompanyPaymentMethodsSuccess(res.data));
      })
      .catch(() => {});
  };
}

export function getCompanyPaymentTerms() {
  return dispatch => {
    api
      .getCompanyPaymentTerms()
      .then(res => {
        dispatch(onGetCompanyPaymentTermsSuccess(res.data));
      })
      .catch(() => {});
  };
}



// WEBPACK FOOTER //
// ./src/actions/dropdowns.actions.js